/**
 * The one fallback zone in this app.
 *
 * Every timestamp renders in its **site's** `timezone` column (D-13 /
 * 01-PRODUCT-SPEC §231). This is what a screen uses when there is no site to
 * ask — a contract record, an audit event, a person — or while the site list
 * is still in flight. It is a fallback, never "the" zone: fifteen files used
 * to hardcode it, three of them on rows that carried a real zone of their own.
 */
export const FALLBACK_TIME_ZONE = 'America/Montreal';
